import React, { FunctionComponent, useState } from 'react';
import { Button } from '../../tailwindcomponents';
import { Search, DirectionsWalk, Work } from '../../components/icons';
import { Typography, TextField } from './../../tailwindcomponents';
import { securityResult } from '../../types/security';
import SecurityApi from '../../api/security';

type AmountControlsProps = {
    selectedReport: securityResult,
    refresh: Function,
    user: number,
    isSecurityAdmin: Boolean
}

const AmountControls: FunctionComponent<AmountControlsProps> = ({ selectedReport, refresh, user, isSecurityAdmin }) => {
    const [handSearches, setHandSearches] = useState<number>(selectedReport.report.amount_hand_searched);
    const [employees, setEmployees] = useState<number>(selectedReport.report.amount_employee_entered);
    const [luggages, setLuggages] = useState<number>(selectedReport.report.amount_luggages);
    const onEmployeeSubmit = () => {
        SecurityApi.UpdateAmountEmployeeEntered(employees, selectedReport.report.report_id, user).then(res => {
            refresh();
        });
    }
    const onSearchesSubmit = () => {
        SecurityApi.UpdateAmountHandSearches(handSearches, selectedReport.report.report_id, user).then(res => {
            refresh();
        });
    }
    const onBaggagesSubmit = () => {
        SecurityApi.UpdateAmountLuggages(luggages, selectedReport.report.report_id, user).then(res => {
            refresh();
        });
    }
    const onEmployeesEnteredChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value === null || event.target.value === undefined || event.target.value === "") {
            setEmployees(parseInt("0"));
        }
        else {
            if (typeof parseInt(event.target.value) === "number") {
                setEmployees(parseInt(event.target.value));
            }
        }
    }
    const onSearchesEnteredChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value === null || event.target.value === undefined || event.target.value === "") {
            setHandSearches(0);
        }
        else {
            if (typeof parseInt(event.target.value) === "number") {
                setHandSearches(parseInt(event.target.value));
            }
        }
    }
    const onBaggagesEnteredChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value === null || event.target.value === undefined || event.target.value === "") {
            setLuggages(0);
        }
        else {
            if (typeof parseInt(event.target.value) === "number") {
                setLuggages(parseInt(event.target.value));
            }
        }
    }

    return (
        <div className="flex flex-wrap">
            <div className="w-full lg:w-1/3 mb-2">
                {isSecurityAdmin && !selectedReport.report.closed ?
                    <div className="flex w-full">
                        <div className="flex flex-wrap w-1/3 mt-3">
                            <div className="w-1/4">
                                <DirectionsWalk />
                            </div>
                            <div className="w-3/4">
                                <Typography text="How many Employees" variant="subtitle1" />
                            </div>
                        </div>
                        <div className="flex flex-row flex-wrap w-2/3 gap-4">
                            <div className="w-1/3">
                                <TextField
                                    label="Employees"
                                    size="small"
                                    defaultValue={0}
                                    variant="standard"
                                    value={employees === 0 ? "" : employees}
                                    onChange={(event) => onEmployeesEnteredChanged(event)}
                                />
                            </div>
                            <div className="w-1/3" >
                                <Button className="mt-3" color="primary" variant="contained" onClick={() => onEmployeeSubmit()}>Submit</Button>
                            </div>
                        </div>
                    </div>
                    :
                    <div><Typography text="Employees" variant="subtitle1" />{employees}</div>
                }
            </div>
            <div className="w-full lg:w-1/3 mb-2">
                {isSecurityAdmin && !selectedReport.report.closed ?
                    <div className="flex w-full">
                        <div className="flex flex-wrap w-1/3 mt-3">
                            <div className="w-1/4">
                                <Search />
                            </div>
                            <div className="w-3/4">
                                <Typography text="How many Searches" variant="subtitle1" />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-2/3 gap-4">
                            <div className="w-1/3">
                                <TextField
                                    label="Searches"
                                    size="small"
                                    defaultValue={0}
                                    variant="standard"
                                    value={handSearches === 0 ? "" : handSearches}
                                    onChange={(event) => onSearchesEnteredChanged(event)}
                                />
                            </div>
                            <div className="w-1/3" >
                                <Button className="mt-3" color="primary" variant="contained" onClick={() => onSearchesSubmit()}>Submit</Button>
                            </div>
                        </div>
                    </div>
                    :
                    <div><Typography text="Searches" variant="subtitle1" />{handSearches}</div>
                }
            </div>
            <div className="w-full lg:w-1/3 mb-2">
                {isSecurityAdmin && !selectedReport.report.closed ?
                    <div className="flex w-full">
                        <div className="flex flex-wrap w-1/3 mt-3">
                            <div className="w-1/4">
                                <Work />
                            </div>
                            <div className="w-3/4">
                                <Typography text="How many Baggages" variant="subtitle1" />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-2/3 gap-4">
                            <div className="w-1/3">
                                <TextField
                                    label="Baggages"
                                    size="small"
                                    defaultValue={0}
                                    variant="standard"
                                    value={luggages === 0 ? "" : luggages}
                                    onChange={(event) => onBaggagesEnteredChanged(event)}
                                />
                            </div>
                            <div className="w-1/3">
                                <Button className="mt-3" color="primary" variant="contained" onClick={() => onBaggagesSubmit()}>Submit</Button>
                            </div>
                        </div>
                    </div>
                    :
                    <div><Typography text="Baggages" variant="subtitle1" />{luggages}</div>
                }
            </div>
        </div>
    );
};
export default AmountControls;
